<template>
	<div id="app">

		<p v-if="pageIsLoading">LOADING..</p>
			<themeHeader :key="viewKey" />
			<main id="main">
				<transition name="opacity" >
					<router-view :key="viewKey" />
				</transition>
			</main>
		<themeFooter />
	</div>
	
</template>

<script>

import themeHeader from '@/components/ThemeHeader'
import themeFooter from '@/components/ThemeFooter'

import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
	name: 'App',
	components: {
		themeHeader,
		themeFooter
	},
	data() {
		return {
			viewKey: window.location.pathname,
			pageisInit: false,
			debug: null,
			postData: null,
			routerTitle: '/' + WPVUE.site_title,
		}
	},
	computed: {
		...mapGetters([
			'getStoreVersion',
			'getCurrentPageMeta',
			'pageIsLoading'
		]),
	},
	watch: {
		$route(to,from) {
			this.viewKey = window.location.pathname
			//this.loadPageByRoute()
		},
		getCurrentPageMeta(val){
			if(val) this.routerTitle = ' - ' + val.title
		},
		pageIsLoading(val){
			if(!val) {
				this.$nextTick(() => {
					const preloader = document.getElementById('preloader-page');
					if(preloader) document.getElementById('preloader-page').classList.add("loaded");
				})
			}
		},
		// hash scroll
		currentPage(val){
			if(val){
				this.$nextTick(() => {
					if(window.location.search){
						const hash = location.search.substring(1);
						const el = document.getElementById(hash);
						if(el) $('html, body').animate({scrollTop: el.offsetTop + 20} ,450);
					} 
				})
			}
		}
	},
	methods: {
		...mapActions([
			'loadPageByRoute',
			'loadEverything',
			'appHearthBeatVersion',
			'loadAppCache'
		]),
      	...mapMutations({
			setAppVersion: 'UPDATE_APP_VERSION',
       	 	setPageLoading: 'CHANGE_PAGE_IS_LOADING',
		}),
		loadDataIfNotLoaded(){
            const VM = this
            if(!VM.isLoadedEverything && !VM.isLoadingEverything){
				VM.loadEverything();
            }
        },
		make404(){
			console.log('%c PAGE NOT FOUND GO 404')
		},
		removeNotUpdatingMeta(){
			const toRemove = [
				'meta[name=description]',
				'meta[name=keywords]',
				'meta[name=author]',
				'meta[property="og:title"]',
				'meta[property="og:description"]',
				'meta[property="og:url"]',
				'meta[property="og:site_name"]',
				'meta[name="twitter:title"]',
				'meta[name="twitter:description"]'
			];
			toRemove.forEach(element => {
				let item = document.head.querySelector(element);
				if(item) item.remove();
			});
		},
		
	},
	mounted() {
		this.loadDataIfNotLoaded()
		//  not working by now
		/* this.loadPageByRoute().then(e =>{
        	//
		}) */
		this.removeNotUpdatingMeta()
	},
	metaInfo() {
		return {
			title: (this.getCurrentPageMeta)? this.getCurrentPageMeta.title : this.routerTitle,
			titleTemplate: (this.getCurrentPageMeta)? this.getCurrentPageMeta.site_name+' - %s' : WPVUE.site_name+' '+this.routerTitle,
			link: [
				{ rel: 'canonical', href: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.url) : window.location.href },
			],
			meta: [
				{ 
					vmid: 'description', 
					name: 'description', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.description) : WPVUE.site_name+' '+this.routerTitle 
				},
				{ 
					vmid: 'keywords',
					name: 'keywords', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.keywords) : '' 
				},
				{ 
					vmid: 'author',
					name: 'author', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.author) : 'Morten Bruvold AS' 
				},
				{ 
					vmid: 'og:title', 
					property: 'og:title', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.og.title) : WPVUE.site_name+' '+this.routerTitle 
				},
				{ 
					vmid: 'og:description', 
					property: 'og:description', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.og.title) : WPVUE.site_name+' '+this.routerTitle 
				},
				{ 
					vmid: 'og:url', 
					property: 'og:url', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.og.url) : window.location.href 
				},
				{ 
					mid: 'og:site_name', 
					property: 'og:site_name', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.og.site_name) : WPVUE.site_name 
				},
				{ 
					mid: 'twitter:title', 
					name: 'twitter:title', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.twitter.title) : WPVUE.site_name+' '+this.routerTitle 
				},
				{ 
					mid: 'twitter:description', 
					name: 'twitter:description', 
					content: (this.getCurrentPageMeta)? (this.getCurrentPageMeta.twitter.title) : WPVUE.site_name+' '+this.routerTitle 
				},
			]
		}
	}
}
</script>

<style lang="scss">
	@import '@/assets/scss/main.scss';
	.opacity-enter-active, .opacity-leave-active {
		transition: opacity .25s ease-in;
		will-change: opacity;
	}
	.opacity-enter, .opacity-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>
